import { TFunction } from 'i18next'

import { NavbarItem } from '@/components/layout/page-header/page-header.types'

export const VISITORS_UI_VERSION_KEY = 'visitors-ui-version'

export const getVisitorsNavItems = (t: TFunction<['visitors']>): NavbarItem[] => [
  {
    label: t('visitors:toolbar.guests'),
    to: { path: '/dashboard/building-dashboard/visitors/guests' },
  },
  {
    label: t('visitors:toolbar.vendors'),
    to: { path: '/dashboard/building-dashboard/visitors/vendors' },
  },
  {
    label: t('visitors:toolbar.history'),
    to: { path: '/dashboard/building-dashboard/visitors/history' },
  },
]
